module.exports = __webpack_public_path__ + "Gotham-Medium.b3353e354bcf2bbe4ba0.woff2";


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/assets/fonts/Gotham-Medium.woff2
// module id = ../../../../../src/assets/fonts/Gotham-Medium.woff2
// module chunks = 2